import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CalendarToday, LocationOn } from '@material-ui/icons'
import { format } from 'date-fns'
import { isNil } from 'lodash'

import { themeConWeb } from '@app/util/modernThemeConweb'

const useStyles = makeStyles({
  card: {
    padding: '0',
  },
  orderInfoText: {
    fontWeight: 'bold',
  },
})

const OrderInfoRow = ({ icon, text }) => {
  const classes = useStyles()
  return (
    <Box alignItems="center" display="flex" flexDirection="row" marginBottom={3} paddingX={2}>
      <Box color={themeConWeb.color.brandPrimary} marginRight={2}>
        {icon}
      </Box>
      <Typography className={classes.orderInfoText}>{text}</Typography>
    </Box>
  )
}

const DeliveryDetails = ({ location, deliveryDropoff }) => {
  if (isNil(location) || isNil(deliveryDropoff)) return null

  const {
    deliveryLocationName,
    address: { street },
  } = location
  const { deliveryDateTime } = deliveryDropoff
  const locationName =
    deliveryLocationName === street // If the location name and the address street are the same, display only one of them (dynamic drops)
      ? deliveryLocationName
      : `${deliveryLocationName} - ${street}`

  return (
    <>
      {deliveryDropoff && (
        <OrderInfoRow
          icon={<CalendarToday />}
          text={format(deliveryDateTime, 'dddd, MMMM Do [at] h:mm A')}
        />
      )}
      {location && <OrderInfoRow icon={<LocationOn />} text={locationName} />}
    </>
  )
}

export default DeliveryDetails
